(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanchwala-header"] && !Shopify.designMode) return;
  try {
    
  
  // Initialize header on load
  // document.addEventListener('DOMContentLoaded', function() {
  //   // Set initial active class based on current URL
  //   const currentPath = window.location.pathname;
  //   document.querySelectorAll('.kanchwala-header__nav a, .kanchwala-mobile-menu__nav a').forEach(link => {
  //     if (link.getAttribute('href') === currentPath) {
  //       link.classList.add('active');
  //     }
  //   });
  // });

  
const uiCopy = {
  ar: {
    currencyPrefix: '',
    currencySuffix: ' د.ك',
    cartWeight: 'الوزن',
    cartGoldWeight: 'وزن الذهب',
    cartSize: 'المقاس',
    cartQty: 'العدد',
    cartTotalPrice: 'السعر الإجمالي',
    removeItem: 'شيلها',
    uploadChange: 'غيّر الصور',
    preparingOrder: 'دقيقة... قاعدين نجهز طلبك',
    checkoutButton: 'كمّل الطلب',
    alertIntro: 'نسخة تجريبية:',
    alertCivilName: 'اسم البطاقة المدنية',
    alertCivilNumber: 'رقم البطاقة المدنية',
    alertPhone: 'رقم الهاتف',
    alertImages: 'عدد الصور المرفوعة',
    alertConsent: 'الموافقة',
    alertYes: 'نعم',
    alertCartTotal: 'إجمالي السلة',
    alertCheckoutNote: 'بالمتجر الفعلي راح نوديك صفحة الدفع بعد ما نحفظ هالبيانات.',
    langButton: 'English',
    langAria: 'Switch to English'
  },
  en: {
    currencyPrefix: 'KWD ',
    currencySuffix: '',
    cartWeight: 'Weight',
    cartGoldWeight: 'Gold weight',
    cartSize: 'Size',
    cartQty: 'Qty',
    cartTotalPrice: 'Total price',
    removeItem: 'Remove',
    uploadChange: 'Change images',
    preparingOrder: 'One moment... preparing your order',
    checkoutButton: 'Complete order',
    alertIntro: 'Demo preview:',
    alertCivilName: 'Civil ID name',
    alertCivilNumber: 'Civil ID number',
    alertPhone: 'Phone',
    alertImages: 'Uploaded images',
    alertConsent: 'Consent',
    alertYes: 'Yes',
    alertCartTotal: 'Cart total',
    alertCheckoutNote: 'On the live store, this would continue to checkout after saving these details.',
    langButton: 'العربية',
    langAria: 'التبديل إلى العربية'
  }
};

function getCurrentLanguage() {
  return localStorage.getItem('kanchwala_lang') || 'ar';
}

function t(key) {
  const lang = getCurrentLanguage();
  return uiCopy[lang]?.[key] ?? uiCopy.ar[key] ?? key;
}

function localizedValue(value) {
  if (value && typeof value === 'object') {
    return value[getCurrentLanguage()] || value.ar || value.en || '';
  }
  return value || '';
}


function applyLanguage() {
  const lang = getCurrentLanguage();
  const root = document.documentElement;
  root.lang = lang;
  root.dir = lang === 'en' ? 'ltr' : 'rtl';

  document.querySelectorAll('[data-en]').forEach(el => {
    if (!el.hasAttribute('data-ar')) {
      el.setAttribute('data-ar', el.textContent);
    }
    el.textContent = lang === 'en' ? el.getAttribute('data-en') : el.getAttribute('data-ar');
  });

  document.querySelectorAll('[data-en-html]').forEach(el => {
    if (!el.hasAttribute('data-ar-html')) {
      el.setAttribute('data-ar-html', el.innerHTML);
    }
    el.innerHTML = lang === 'en' ? el.getAttribute('data-en-html') : el.getAttribute('data-ar-html');
  });

  document.querySelectorAll('[data-en-placeholder]').forEach(el => {
    if (!el.hasAttribute('data-ar-placeholder')) {
      el.setAttribute('data-ar-placeholder', el.getAttribute('placeholder') || '');
    }
    el.setAttribute('placeholder', lang === 'en' ? el.getAttribute('data-en-placeholder') : el.getAttribute('data-ar-placeholder'));
  });

  document.querySelectorAll('[data-en-aria]').forEach(el => {
    if (!el.hasAttribute('data-ar-aria')) {
      el.setAttribute('data-ar-aria', el.getAttribute('aria-label') || '');
    }
    el.setAttribute('aria-label', lang === 'en' ? el.getAttribute('data-en-aria') : el.getAttribute('data-ar-aria'));
  });

  document.querySelectorAll('[data-en-title]').forEach(el => {
    if (!el.hasAttribute('data-ar-title')) {
      el.setAttribute('data-ar-title', el.textContent);
    }
    el.textContent = lang === 'en' ? el.getAttribute('data-en-title') : el.getAttribute('data-ar-title');
  });

  document.querySelectorAll('[data-lang-toggle]').forEach(el => {
    el.textContent = t('langButton');
    el.setAttribute('aria-label', t('langAria'));
  });

  const uploadChange = document.querySelector('.kanchwala-upload-change');
  if (uploadChange) uploadChange.textContent = t('uploadChange');

  const checkoutBtn = document.getElementById('kanchwalaCheckoutBtn');
  if (checkoutBtn && checkoutBtn.style.pointerEvents !== 'none') {
    checkoutBtn.textContent = t('checkoutButton');
  }
}

applyLanguage();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanchwala-hero"] && !Shopify.designMode) return;
  try {
    
  // Smooth scroll to next section when scroll indicator is clicked
  document.addEventListener('DOMContentLoaded', function() {
    const scrollIndicator = document.querySelector('.kanchwala-hero__scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.addEventListener('click', function() {
        const nextSection = document.querySelector('.kanchwala-trust-bar, .kanchwala-section, .kanchwala-collections-grid');
        if (nextSection) {
          nextSection.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  })

  } catch(e) { console.error(e); }
})();
})();
